// extracted by mini-css-extract-plugin
export var image = "placeCard-module--image--Zm2zu";
export var openingHours = "placeCard-module--openingHours--+FGcy";
export var placeCard = "placeCard-module--placeCard--c4XC0";
export var textContainer = "placeCard-module--textContainer--Ck7ba";